export default __webpack_public_path__ + "static/media/orangeMarker.253bee1a.svg";